import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";

export default {
    /*
    |--------------------------------------------------------------------------
    | projects Routes
    |--------------------------------------------------------------------------|
    */

    path: 'projects',
    name: 'projects',
    redirect: '/projects/list',
    children: [ 
        {
            path: 'list',
            component: () => import('@/Modules/Projects/views/Projects/Index.vue'),
            name: 'projects-index',
            meta: { requiresAccess: [moduleAbilities.NOTARIAL_REPERTORY,moduleAbilities.PROJECT],
                requiresPermission : abilities.VIEW_PROJECT
            },
        },
        {
            path: 'transferred/list',
            component: () => import('@/Modules/Projects/views/Projects/Transferred.vue'),
            name: 'projects-transferred-index',
            meta: { requiresAccess: [moduleAbilities.NOTARIAL_REPERTORY,moduleAbilities.PROJECT],
                requiresPermission : abilities.VIEW_PROJECT
            },
        },
        {
            path: ':id/view',
            name: 'projects-view',
            meta: { requiresAccess: [moduleAbilities.NOTARIAL_REPERTORY,moduleAbilities.PROJECT],
                requiresPermission : abilities.VIEW_PROJECT, showLoader: true },
            component: () => import('@/Modules/Projects/views/Projects/View.vue'),
            redirect: { name: 'projects-overview' },
            children: [
                {
                    path: '',
                    name: 'projects-overview',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/OverViewComponent.vue')
                },
                {
                    path: 'fiche',
                    name: 'projects-fiche',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/FicheComponent.vue')
                },
                {
                    path: 'information',
                    name: 'projects-information',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/DetailComponent.vue')
                },
                {
                    path: 'steps',
                    name: 'projects-steps',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/StepComponent.vue')
                },
                {
                    path: 'tasks',
                    name: 'projects-tasks',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Tasks/TaskIndex.vue')
                },
                {
                    path: 'budget',
                    name: 'projects-budget',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Budget/Index.vue')
                },
                {
                    path: 'documents',
                    name: 'projects-documents',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/DirectoriesComponent.vue')
                },
                {
                    path: 'comments',
                    name: 'projects-comments',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/CommentsComponent.vue')
                },
                {
                    path: 'reports',
                    name: 'projects-reports',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/ReportsComponent.vue')
                },
                {
                    path: 'chats',
                    name: 'projects-chats',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Chat/components/ChatBox.vue')
                },
                {
                    path: 'actuality',
                    name: 'projects-actuality',
                    component: () => import('@/Modules/NewsFeed/views/Feed/Index.vue')
                },
                {
                    path: 'formality',
                    name: 'projects-formality',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/FormalitiesComponent.vue')
                },
                {
                    path: 'estates',
                    name: 'projects-estates',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/EstateComponent.vue')
                },
                {
                    path: 'rdv',
                    name: 'projects-rdv',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/CRM/views/Appointment/components/List.vue')
                },
                {
                    path: 'historical',
                    name: 'projects-historical',
                    meta: { showLoader: false },
                    component: () => import('@/Modules/Projects/views/Projects/components/MailHistory.vue')
                }
            ]
        },
        {
            path: ':project/tasks/:id/details',
            component: () => import('@/Modules/Projects/views/Tasks/View.vue'),
            name: 'tasks-view',
            meta: { requiresAccess: [moduleAbilities.NOTARIAL_REPERTORY,moduleAbilities.PROJECT],
                requiresPermission : abilities.VIEW_PROJECT },
        },
        {
            path: 'settings-projects',
            name: 'settings-projects',
            component: () => import('@/Modules/Projects/views/Setting/Layouts/BaseProjectsSetting.vue'),
            meta: { requiresAccess: [moduleAbilities.NOTARIAL_REPERTORY,moduleAbilities.PROJECT]},
            children: [
                {
                    name: "settings-projects-steps",
                    path: "steps",
                    component: () => import('@/Modules/Projects/views/Setting/Steps/Index.vue'),
                    meta: { requiresPermission : abilities.VIEW_MILESTONE },
                },
                {
                    name: "settings-projects-status",
                    path: "status",
                    component: () => import('@/Modules/Projects/views/Setting/Status/Index.vue'),
                    meta: { requiresPermission : abilities.VIEW_COLUMN },
                },
                {
                    name: "settings-projects-priorities",
                    path: "priorities",
                    component: () => import('@/Modules/Projects/views/Setting/Priorities/Index.vue'),
                    meta: { requiresPermission : abilities.VIEW_PRIORITY },
                },
                {
                    name: "settings-projects-category-groups",
                    path: "category/groups",
                    component: () => import('@/Modules/Projects/views/Setting/CategoryGroups/Index.vue'),
                    meta: { requiresPermission : abilities.VIEW_CATEGORIES },
                },
                {
                    name: "settings-projects-categories",
                    path: "categories",
                    component: () => import('@/Modules/Projects/views/Setting/Categories/Index.vue'),
                    meta: { requiresPermission : abilities.VIEW_CATEGORIES },

                },
                {
                    name: "settings-projects-categories-create",
                    path: "categories/create",
                    component: () => import('@/Modules/Projects/views/Setting/Categories/Creation.vue'),
                    meta: { requiresPermission : abilities.CREATE_CATEGORIES },
                },
                {
                    name: "settings-projects-categories-edit",
                    path: "categories/:id/edit",
                    component: () => import('@/Modules/Projects/views/Setting/Categories/Detail.vue'),
                    meta: { requiresPermission : abilities.VIEW_CATEGORIES },
                },
                {
                    name: "settings-projects-contact-status",
                    path: "contact/status",
                    component: () => import('@/Modules/Projects/views/Setting/ContactStatus/Index.vue'),
                    meta: { requiresPermission : abilities.VIEW_CATEGORIES },
                },
                {
                    name: "settings-projects-property-specifications",
                    path: "property/specifications",
                    component: () => import('@/Modules/Projects/views/Setting/Property/Index.vue'),
                    meta: { requiresPermission : abilities.VIEW_CATEGORIES },
                },
            ]
        },
        {
            path: 'reports',
            component: () => import('@/Modules/Projects/views/Reports/Index.vue'),
            name: 'reports-index',
            meta: { requiresAccess: [moduleAbilities.NOTARIAL_REPORT],
                requiresPermission : abilities.REPORT_PROJECT
            },
        },
        
        {
            path: 'user/performances',
            component: () => import('@/Modules/Projects/views/Performance/Index.vue'),
            name: 'performance-index',
            meta: { requiresAccess: [moduleAbilities.NOTARIAL_REPORT],
                requiresPermission : abilities.VIEW_USER_PERFORMANCE
            },
        },
    ]

}
